import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {SectionProps} from '../../utils/SectionProps';
import Input from '../elements/Input';

const propTypes = {
    ...SectionProps.types,
    split: PropTypes.bool
}

const defaultProps = {
    ...SectionProps.defaults,
    split: false
}

const CtaTitle = ({
                 className,
                 topOuterDivider,
                 bottomOuterDivider,
                 topDivider,
                 bottomDivider,
                 hasBgColor,
                 invertColor,
                 split,
                 ...props
             }) => {

    const outerClasses = classNames(
        'cta section center-content-mobile reveal-from-bottom',
        topOuterDivider && 'has-top-divider',
        bottomOuterDivider && 'has-bottom-divider',
        hasBgColor && 'has-bg-color',
        invertColor && 'invert-color',
        className
    );

    const innerClasses = classNames(
        'cta-inner section-inner',
        topDivider && 'has-top-divider',
        bottomDivider && 'has-bottom-divider',
        split && 'cta-split'
    );

    return (
        <section
            {...props}
            className={outerClasses}
            id="cta"
        >
            <div className="container">
                <div
                    className={innerClasses}
                >
                    <div className="cta-slogan">
                        <h3 className="m-0 h2 text-color-secondary">
                            見学してみる？ >
                        </h3>
                    </div>
                </div>
            </div>
        </section>
    );
}

CtaTitle.propTypes = propTypes;
CtaTitle.defaultProps = defaultProps;

export default CtaTitle;